import axios from "axios";
import { jobApplicationUrl } from "../utils";

export const fetchJobApplication = async (jobApplicationId: string) => {
  return await axios.get(jobApplicationUrl(jobApplicationId));
};
